import { PDFDocument, StandardFonts } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import { drawTextOnPage, calculateCenterX } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/cons_esi_th.pdf";
const Font = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormConsentEpiduralSteroidInjectTH = async (props: any) => {
  try {
    const existingPdfBytes = await fetch(PDF).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Loading Custom Font
    const fontUrl = Font;
    const fontBytes = await fetch(fontUrl).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);
    const customFont = await pdfDoc.embedFont(fontBytes);
    const zapFont = await pdfDoc.embedFont(StandardFonts.ZapfDingbats);

    const pages = pdfDoc.getPages();
    const fontSize = 15; //*

    // Common Text
    const commonTextCoordinates = [
      { text: props.items?.patientFullName, x: 424, y: 741 },
      { text: props.items?.hn, x: 424, y: 728 },
      { text: props.items?.patientEncounter, x: 541, y: 728},
      { text: props.items?.birthdateAd, x: 437, y: 715 },
      { text: props.items?.age.toString(), x: 530, y: 715 },
      { text: props.items?.formatGender, x: 430, y: 702 },
    ];

    // Page 1
    const firstTextCoordinates = [
      { text: props.items?.formatPatient, x: 145, y: 592 },
      { text: props.items?.formatDoctor || "-", x: 253, y: 568 },
    ];

    // Page 3
    const thirdTextCoordinates = [
      {
        text: props.items?.patientFullName,
        x: calculateCenterX(props.items?.patientFullName, customFont, fontSize, 61, 190),
        y: 460
      },
      {
        text: props.items?.doctorFullName || "",
        x: calculateCenterX(props.items?.doctorFullName || "", customFont, fontSize, 61, 190),
        y: 390
      },
    ];

    const thirdDateTimeTextCoordinates = [
      { text: props.items?.signedDate, x: 80, y: 344 },
      { text: props.items?.printTime, x: 146, y: 344 },
    ];

    drawTextOnPage(pages[0], [...commonTextCoordinates, ...firstTextCoordinates], customFont, fontSize);
    drawTextOnPage(pages[1], commonTextCoordinates, customFont, fontSize);
    drawTextOnPage(pages[2], [...commonTextCoordinates, ...thirdTextCoordinates], customFont, fontSize);
    drawTextOnPage(pages[2], thirdDateTimeTextCoordinates, customFont, 10);

    const modifiedPdfBytes = await pdfDoc.save();
    const getAsBase64 = await pdfDoc.saveAsBase64();
    const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
    const modifiedPdfUrl = URL.createObjectURL(blob);

    return { uint8Array: modifiedPdfBytes, blobUrl: modifiedPdfUrl, blobRaw: blob, base64String: getAsBase64 }

  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormConsentEpiduralSteroidInjectTH;